import { render, staticRenderFns } from "./62.vue?vue&type=template&id=2030d54d&scoped=true&"
var script = {}
import style0 from "./62.vue?vue&type=style&index=0&id=2030d54d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030d54d",
  null
  
)

export default component.exports